import styled from 'styled-components';

import {Link} from 'components/ui-kit/Link';
import {Tag} from 'components/ui-kit/Tags';
import {colors, font} from 'theme';

export const ColumnsWrapper = styled.div`
    display: flex;
    gap: 40px;
    max-width: 600px;
    margin-bottom: 40px;
    margin-top: 36px;
`;

export const Column = styled.div`
    margin-bottom: 16px;
    flex: 1;
`;

export const Typography = styled.div`
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.1px;
    word-wrap: break-word;
`;

export const TitleWrapper = styled.div`
    display: flex;
    gap: 20px;
    align-items: center;
`;

export const Title = styled(Typography)`
    text-transform: uppercase;
    font-weight: 700;
`;

export const HeaderTypography = styled(Typography)`
    font-size: 13px;
    line-height: 14px;
    color: ${colors.textSecondary};
    margin-bottom: 6px;
`;

export const HeaderText = styled(Typography)`
    font-size: 13px;
    line-height: 14px;
    color: ${colors.textPrimary};
    margin-bottom: 6px;
`;

export const CustomLink = styled(Link)`
    white-space: nowrap;
`;

export const NavigationContainer = styled.div`
    display: flex;
    justify-content: space-between;

    button {
        width: 120px;
        color: ${colors.brandPrimary};
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }
`;

export const ErrorsWrapper = styled.div`
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    margin-bottom: 20px;
    margin-top: -24px;
`;

export const Error = styled(Tag)`
    padding: 8px 16px;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    color: ${colors.white};
    background-color: ${colors.danger};
    border-radius: 6px;
    width: auto;
`;

export const DetailsWrapper = styled.div`
    display: flex;
    gap: 16px;
    align-items: self-start;
`;
export const Divider = styled.hr`
    width: 100%;
    height: 1px;
    margin: 24px 0;
    padding: 0;
    outline: none;
    border: none;
    background-color: ${colors.border};
`;

export const Subtitle = styled.h2`
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 16px;
    font-family: ${font.family.primary};
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    text-transform: uppercase;
`;
